export const ZONE_APPLICANTS_PORTALS = {
  admin: "admin-portal",
  company: "company-portal",
};

/** Drill-in state lives in the URL so browser back returns to the zones list. */
export const ZONE_APPLICANTS_URL_PARAMS = {
  zone: "zone",
};

export const isAdminZoneApplicantsPortal = (portalVariant) =>
  portalVariant === ZONE_APPLICANTS_PORTALS.admin;

/** One field matches both name and ID — no client-side split needed. */
export const buildZoneApplicantsSearchParams = (search) => {
  const query = String(search || "").trim();
  return query ? { user_name_or_id: query } : {};
};

/** Applicants already sitting in this zone, supervisors excluded. */
export const buildZoneApplicantsParams = ({ eventId, zoneId }) => ({
  event_id: eventId,
  zone_id: zoneId,
  is_supervisor: false,
  order_by_created_at: "asc",
});

/** Approved applicants not yet in any zone — the pool the assign modal picks from. */
export const buildAssignableApplicantsParams = ({ eventId }) => ({
  event_id: eventId,
  status: "approved",
  is_supervisor: false,
  is_assigned_to_zone: false,
  order_by_created_at: "asc",
});
